import { render, staticRenderFns } from "./TransferenciaMatrizEFilialProposta.vue?vue&type=template&id=5a099cf4"
import script from "./TransferenciaMatrizEFilialProposta.vue?vue&type=script&lang=js"
export * from "./TransferenciaMatrizEFilialProposta.vue?vue&type=script&lang=js"
import style0 from "./TransferenciaMatrizEFilialProposta.vue?vue&type=style&index=0&id=5a099cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports